import { render } from "./SubscriptionPlan.vue?vue&type=template&id=50b7a6c6&scoped=true"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=js"

import "./SubscriptionPlan.vue?vue&type=style&index=0&id=50b7a6c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b7a6c6"]])

export default __exports__